import { Road as RoadDto, RoadItem as RoadItemDto } from "src/app/proxy/roads/models";

export class RoadItem {
  id: number;
  activityGroupId: number;
  roadId: number;
  activityGroupName: string;
  name: string;
  quantity: number;
  quantityProgress: number;
  quantityCertificated: number;
  total: number;
  totalProgress: number;
  totalCertificated: number;
  canBeAdded: boolean;
  inputType: number;
  itemType: number;
  inputTypeText: string;
  itemTypeText: string;
  unitName: string;
  roadGroupParameterPosition: number;
  roadGroupPosition: number;
  activityGroupOrderText: string;

  constructor(dto: RoadItemDto) {
    Object.assign(this, dto);
  }
}

export class Road {
  id: number;
  projectId: number;
  name: string;
  length: number;
  mgPitDistance: number;
  basePitDistance: number;
  progress: number;
  certificated: number;
  amountProgress: number;
  amountCertificated: number;
  closed: boolean;
  lastProgress: string;
  lastCertification: string;
  scope: number;
  scopeText: string;
  construction: number;
  constructionText: string;
  ubication: number;
  ubicationText: string;
  type: number;
  typeText: string;
  version: number;
  operation: string;
  items: RoadItem[] = [];

  constructor(dto: RoadDto) {
    Object.assign(this, dto);
    this.items = (dto.items ?? []).map(item => new RoadItem(item));
  }
}
